import { campaignsSlice } from '../../campaigns';
import { openAlertPopup } from '../../popup/actions';
import { TapiMutationFactory } from '../baseQuery';

export const getPutResetCampaignPreflight: TapiMutationFactory<'V1CampaignsResetPreflightUpdate'> =
  (builder) =>
    builder.mutation({
      query: ({ id }) => ({
        url: `/campaigns/${id}/reset_preflight`,
        method: 'PUT',
      }),
      onQueryStarted: async ({ id }, { dispatch, queryFulfilled }) => {
        try {
          const response = await queryFulfilled;
          const toUpdateCampaign = response.data.data;

          dispatch(
            campaignsSlice.actions.campaignUpdated({
              id,
              changes: toUpdateCampaign.attributes,
            })
          );
        } catch (error) {
          dispatch(
            openAlertPopup({
              title: 'Error',
              description:
                'There was an error with your request, please try again.',
            })
          );
          console.log(`error resetting preflight date ${error}`);
        }
      },
    });
